import { useMutation, UseMutationResult } from "react-query"
import { localConfig } from "../../../Configs/localConfig"
import { errorAlert, loadingAlert, successAlert } from "../../../utils/alert"
import { api } from "../../api"

interface PropsDeletarCargo {
  cod_cargo: number
  refetch_deletar: Function
}

export const useDeleteCargo = (): {
carregando_deletar_cargo: boolean
mudateDeletarCargo: (params: PropsDeletarCargo) => void
} => {
const mutation: UseMutationResult<Response, Error, PropsDeletarCargo> = useMutation(
  async (params: PropsDeletarCargo) => {
    const {
      cod_cargo,
     refetch_deletar
    } = params

    const config = localConfig()

    loadingAlert({ msg: 'Excluindo...', id: 'delete_cargo' })

    return api
      .delete(
        `/adm/cargo/${cod_cargo}?codConta=${config.conta}`
      )
      .then((response: any) => {
        successAlert('Excluído com sucesso!', 5000, 'delete_cargo')
        refetch_deletar?.()
        return response
      })
      .catch((error: Error) => {
        //@ts-ignore
        let error_response = error?.response?.data
        errorAlert(error_response?.error ?? 'Falha ao excluir fertilizante', 5000, 'delete_cargo')

        throw error
      })
  }
)

return {
  carregando_deletar_cargo: mutation.isLoading,
  mudateDeletarCargo: mutation.mutate,
}
}